import React, {useState, useEffect} from "react";
import {Tabs as AntTabs} from "antd";

const tabVariants = {
    standard: 'standard',
    fullWidth: 'fullWidth',
    scrollable: 'scrollable'
}

const getHash = () => {
    return window.location.hash.slice(1);
}

const setHash = (newHash) => {
    if (newHash) {
        window.location.hash = newHash;
    } else {
        window.history.replaceState(null, null, ' ');
        // window.location.href = window.location.href.replace(/#.*$/, '');
    }
}

const Tabs = props => {
    const {className, contentClassName, variant = tabVariants.standard, onChange, children, defaultActiveKey, activeKey, overrideKey, ...other} = props;
    const [tabItems, setTabItems] = useState([]);
    const [activeTab, setActiveTab] = useState(null);
    let tabProps = {...other};

    const handleOnChange = key => {
        if (activeTab?.key.toString() === key.toString()) return;
        let newActiveTab = tabItems.find(tabItem => tabItem.key.toString() === key.toString());
        if (newActiveTab) {
            setActiveTab(newActiveTab);
            if (typeof onChange === 'function' && onChange) onChange(key);
        }
    }

    useEffect(() => {
        let newTabItems = [];
        const childrenArray = React.Children.toArray(children);
        childrenArray.map((child, index) => {
            newTabItems.push({
                className: child.props.className,
                key: child.key.replace(/^(\.\$)/, ''),
                label: child,
                children: (
                    <div className={'ch-tab-content' + (contentClassName ? ' ' + contentClassName : '')}>
                        {child.props.children}
                    </div>
                ),
                disabled: child.props.disabled,
                hash: (child.props.hash ? child.props.hash : null)
            });
        });
        setTabItems(newTabItems);
    }, [children]);

    useEffect(() => {
        // overrideKey added for SearchResources as it re-renders the tabs every on every search.
        // this way it keeps state outside of the Tabs component so it doesn't always default to first picked tab.
        if(overrideKey){
            handleOnChange(overrideKey);
        }else{
            if (tabItems.length > 0 && activeTab == null) {
                const hash = getHash();
                let loadFromHashTab;
                if (hash) {
                    loadFromHashTab = tabItems.find(tabItem => tabItem.hash === hash);
                }
                if (loadFromHashTab && !loadFromHashTab.disabled) {
                    handleOnChange(loadFromHashTab.key);
                } else if (activeKey && tabItems.some(tab => tab.key === activeKey)) {
                    handleOnChange(activeKey);
                } else if (defaultActiveKey && tabItems.some(tab => tab.key === defaultActiveKey)) {
                    handleOnChange(defaultActiveKey);
                } else {
                    handleOnChange(tabItems[0].key);
                }
            } else if (tabItems.length > 0 && activeKey) {
                if (activeTab?.key.toString() !== activeKey.toString()) {
                    handleOnChange(activeKey);
                }
            }
        }
    }, [tabItems, activeKey]);


    useEffect(() => {
        if (activeTab != null) {
            const hash = getHash();
            if (activeTab.hash) {
                setHash(activeTab.hash);
            } else {
                if (hash && hash !== '') {
                    setHash();
                }
            }
        }
    }, [activeTab]);

    return (
        <AntTabs
            className={'ch-tabs' + (variant === tabVariants.fullWidth ? ' ch-tabs-fullWidth' : '') + (className ? ' ' + className : '')}
            onChange={handleOnChange}
            items={tabItems}
            activeKey={(overrideKey?String(overrideKey):(activeTab ? activeTab.key : undefined))}
            {...tabProps}
        />
    )
}

export default Tabs;
